import { render } from "./GlobalAdminPage.vue?vue&type=template&id=0463b355&scoped=true"
import script from "./GlobalAdminPage.vue?vue&type=script&lang=js"
export * from "./GlobalAdminPage.vue?vue&type=script&lang=js"

import "./GlobalAdminPage.vue?vue&type=style&index=0&id=0463b355&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0463b355"]])

export default __exports__